if (!customElements.get('wls-testimonials')) {
  class WLSTestimonials extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        playingClass: 'is-playing',
        slider: 'js-wls-testimonials-slider',
        list: 'splide__list',
        item: 'splide__slide',
        video: 'js-wls-testimonials-video',
        dots: 'js-wls-splide-navigation-dots',
        arrows: 'js-wls-splide-navigation-arrows',
        arrowPrev: 'js-wls-splide-navigation-arrow-prev',
        arrowNext: 'js-wls-splide-navigation-arrow-next',
        navigation: 'js-wls-splide-navigation',
      };

      this.elements = {
        slider: this.querySelector(`.${this.classes.slider}`),
        list: this.querySelector(`.${this.classes.list}`),
        items: this.querySelectorAll(`.${this.classes.item}`),
        navigation: this.querySelector(`.${this.classes.navigation}`),
      };

      this.resizeHandler = this.handleResize.bind(this);
      this.videoClickHandler = this.handleVideoClick.bind(this);
    }

    /* =====================
      LIFECYCLE
    ===================== */

    connectedCallback() {
      if (this.checkIfEmpty()) return;

      this.init();
      this.bindVideoDelegation();
      window.addEventListener('resize', this.resizeHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.resizeHandler);
      this.stopAllVideos();

      if (this.splide) {
        this.splide.destroy(true);
        this.splide = null;
      }
    }

    /* =====================
      VIDEO LOGIC (DELEGATION)
    ===================== */

    bindVideoDelegation() {
      if (!this.elements.slider) return;

      this.elements.slider.addEventListener(
        'click',
        this.videoClickHandler
      );
    }

    handleVideoClick(e) {
      const video = e.target.closest(`.${this.classes.video}`);
      if (!video) return;

      e.preventDefault();

      const parent = video.closest('.wls-testimonials__slide-video');
      this.toggleVideo(video, parent);
    }

    toggleVideo(video, parent) {
      this.stopAllVideos(video);

      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }

      parent?.classList.toggle(
        this.classes.playingClass,
        !video.paused
      );
    }

    stopAllVideos(exceptVideo = null) {
      const videos = this.querySelectorAll(`.${this.classes.video}`);

      videos.forEach((video) => {
        if (!exceptVideo || video !== exceptVideo) {
          video.pause();
          video.currentTime = 0;

          const parent = video.closest('.wls-testimonials__slide-video');
          parent?.classList.remove(this.classes.playingClass);
        }
      });
    }

    /* =====================
      SPLIDE LOGIC
    ===================== */

    checkIfEmpty() {
      if (!this.elements.list || !this.elements.list.children.length) {
        this.style.display = 'none';
        return true;
      }
      return false;
    }

    init() {
      if (!this.shouldInitialize()) return;
      this.initializeSplide();
    }

    shouldInitialize() {
      if (!this.elements.slider || !this.elements.items.length) return false;

      const width = window.innerWidth;
      const slidesCount = this.elements.items.length;

      if (slidesCount <= 1 && width < 1199) {
        this.elements.navigation.style.display = 'none';
        return false;
      }

      if (slidesCount <= 3 && width >= 1199) {
        this.elements.navigation.style.display = 'none';
        this.elements.list.style.gap = '16px';
        return false;
      }

      this.elements.navigation.style.display = '';
      return true;
    }

    handleResize() {
      clearTimeout(this.resizeTimeout);

      this.resizeTimeout = setTimeout(() => {
        const shouldInit = this.shouldInitialize();

        if (shouldInit && !this.splide) {
          this.initializeSplide();
        } else if (!shouldInit && this.splide) {
          this.stopAllVideos();
          this.splide.destroy(true);
          this.splide = null;
        } else if (this.splide) {
          this.createPagination();
        }
      }, 300);
    }

    initializeSplide() {
      this.prevBtn = this.querySelector(`.${this.classes.arrowPrev}`);
      this.nextBtn = this.querySelector(`.${this.classes.arrowNext}`);
      this.paginationEl = this.querySelector(`.${this.classes.dots}`);

      this.splide = new Splide(this.elements.slider, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        gap: '16px',
        drag: true,
        arrows: false,
        pagination: false,
        clones: 5,
      });

      this.splide.on('mounted', () => {
        this.createPagination();
        this.bindArrows();
      });

      this.splide.on('move', () => {
        this.stopAllVideos();
        this.updatePagination();
      });

      this.splide.mount();
    }

    bindArrows() {
      this.prevBtn?.addEventListener('click', () => this.splide.go('<'));
      this.nextBtn?.addEventListener('click', () => this.splide.go('>'));
    }

    /* =====================
      PAGINATION
    ===================== */

    getPaginationCount() {
      const slidesCount = this.splide.length;

      return slidesCount;
    }

    createPagination() {
      if (!this.paginationEl || !this.splide) return;

      this.paginationEl.innerHTML = '';
      this.paginationDots = [];

      const dotsCount = this.getPaginationCount();

      for (let i = 0; i < dotsCount; i++) {
        const dot = document.createElement('button');
        dot.className = 'wls-reviews__dot';

        dot.addEventListener('click', () => {
          this.splide.go(i);
        });

        this.paginationEl.appendChild(dot);
        this.paginationDots.push(dot);
      }

      this.updatePagination();
    }

    updatePagination() {
      if (!this.paginationDots || !this.splide) return;

      let activeIndex = this.splide.index;
      const isDesktop = window.innerWidth >= 1199;

      if (isDesktop) {
        activeIndex = Math.min(
          activeIndex,
          this.paginationDots.length 
        );
      }

      this.paginationDots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }
  }

  customElements.define('wls-testimonials', WLSTestimonials);
}
